import React, { useEffect, useState } from "react";
import { PAGE } from "../constants/page";
import "../styles/components/Header.scss";
import { isMobile } from "react-device-detect";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import ConfirmationModal from "./ConfirmationModal";
import { Trans, useTranslation } from "react-i18next";
import AuthService from "src/services/AuthService";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import { PersistState, updateLanguage } from "../redux/reducers/PersistSlice";
import { UserConfigState } from "../redux/reducers/UserConfigSlice";
import { useAuth } from "react-oidc-context";
import { Dropdown } from "@els/els-react--dropdown";
import HeaderLogo from "./HeaderLogo";

function ScreeningHeader() {
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const userPrefer = useAppSelector(PersistState);
  const [exitScreening, setExitScreening] = useState(false);
  const brand = sessionStorage.getItem("brand");
  const userSelectedLanguage: any = useAppSelector(PersistState);
  const userConfigDetails: any = useAppSelector(UserConfigState);
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const onExitScreening = async () => {
    if (auth.user?.expired) {
      await AuthService.instance.idleLogout(
        userPrefer?.language || "en",
        auth.user?.expired
      );
    } else {
      setExitScreening(true);
    }
  };

  const handleYes = () => {
    window.removeEventListener("message", handleIframeCommunication, false);
    navigate(
      PAGE.VIEW_PATIENT_DETAILS.replace(":id", location.state.patientDetails.id)
    );
  };
  const handleCancel = () => {
    setExitScreening(false);
  };

  function handleIframeCommunication(e: any) {
    if (e?.data?.message === "closeIframe") {
      window.removeEventListener("message", handleIframeCommunication, false);
      handleYes();
    } else if (e?.data?.message === "exitScreening") {
      onExitScreening();
    }
  }

  const handleLanguageChange = (e: any) => {
    i18n.changeLanguage(e.id);
    dispatch(updateLanguage(e.id));
    //dispatch(hideSuccessMessage(true));
    //dispatch(updatedAsha({ updated: false }));
  };

  useEffect(() => {
    // remove event if already exist
    window.removeEventListener("message", handleIframeCommunication, false);
    //add event
    window.addEventListener("message", handleIframeCommunication, false);

    return () => {
      window.removeEventListener("message", handleIframeCommunication, false);
    };
  }, []);

  return (
    <>
      {!userPrefer.header ? (
        <div className="disha-screening-header">
          <div
            className="container"
            style={{
              position: isMobile ? "initial" : "relative",
              padding: "8px 16px 0px 16px",
            }}
          >
            <div className={"screening-header row"}>
              <div className="col-md-8 col-10">
                <HeaderLogo brand={userPrefer.brand} />
              </div>
              <div className="col-md-4 col-2 text-end pt-2">
                <Dropdown
                  iconSprite="Globe"
                  selected={{
                    label:
                      userConfigDetails?.countryLanguageOptions.filter(
                        (langLabelValueObj: any) => {
                          return (
                            langLabelValueObj.id ===
                            userSelectedLanguage?.language
                          );
                        }
                      )[0]?.label ?? "English",
                  }}
                  showSelectedAsLabel={true}
                  id="language-select"
                  options={userConfigDetails?.countryLanguageOptions.map(
                    (options: {}) => {
                      return {
                        ...options,
                        onClick: handleLanguageChange,
                      };
                    }
                  )}
                  flyoutProps={{
                    placement: "bottom-end",
                    pointer: false,
                    pointerType: "primary",
                  }}
                  className="textTransform"
                />
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {exitScreening && (
        <ConfirmationModal
          onCancel={handleCancel}
          onYes={handleYes}
          onClose={handleCancel}
          messageKey="exit_screening_message"
          titleKey="exit_screening"
          yesKey="exit_screening_confirmation"
          cancelkey="cancel_exit_screening"
          isCenter={true}
        />
      )}
    </>
  );
}

export default ScreeningHeader;
